import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { X, Lightning } from "@phosphor-icons/react";
import axios from "axios";
import { API } from "@/App";

export default function PromoBanner({ user }) {
  const location = useLocation();
  const [promo, setPromo] = useState(null);
  const [dismissed, setDismissed] = useState(() => localStorage.getItem("promo_dismissed_DYNASTY50") === "1");
  const [finalDismissed, setFinalDismissed] = useState(() => localStorage.getItem("promo_dismissed_DYNASTY50_final") === "1");

  useEffect(() => {
    try {
      const cached = sessionStorage.getItem("promo_dynasty50");
      if (cached) {
        const c = JSON.parse(cached);
        if (c.fetched_at > Date.now() - 3600000) { setPromo(c.data); return; }
      }
    } catch { /* ignore */ }
    axios.get(`${API}/billing/promo/dynasty50`)
      .then(res => {
        setPromo(res.data);
        try { sessionStorage.setItem("promo_dynasty50", JSON.stringify({ data: res.data, fetched_at: Date.now() })); } catch { /* ignore */ }
      })
      .catch(() => {});
  }, []);

  const isPro = ["pro", "commissioner"].includes(user?.subscription);
  if (isPro || !promo?.active || location.pathname === "/dynasty50") return null;
  const msLeft = promo.expires_at * 1000 - Date.now();
  if (msLeft <= 0) return null;
  const isFinal = msLeft < 24 * 3600 * 1000;
  if (isFinal ? finalDismissed : dismissed) return null;
  const daysLeft = Math.max(1, Math.ceil(msLeft / 86400000));
  const hoursLeft = Math.max(1, Math.ceil(msLeft / 3600000));

  if (isFinal) {
    return (
      <div className="bg-[#ff3b30] text-white" data-testid="promo-banner">
        <div className="max-w-[1600px] mx-auto px-3 sm:px-6 py-1.5 flex items-center justify-center gap-2 relative">
          <Link to="/dynasty50" className="flex items-center gap-1.5 no-underline text-white text-[11px] sm:text-xs font-bold uppercase tracking-wide hover:underline animate-pulse" data-testid="promo-banner-link">
            <Lightning size={13} weight="fill" />
            LAST CHANCE: 50% OFF PRO ENDS TONIGHT — {hoursLeft}h left
            <span className="hidden sm:inline font-normal normal-case">· claim it before midnight →</span>
          </Link>
          <button
            onClick={() => { setFinalDismissed(true); localStorage.setItem("promo_dismissed_DYNASTY50_final", "1"); }}
            className="absolute right-2 sm:right-4 text-white/60 hover:text-white"
            aria-label="Dismiss promo banner"
            data-testid="promo-banner-dismiss"
          >
            <X size={14} weight="bold" />
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-[#ccff00] text-black" data-testid="promo-banner">
      <div className="max-w-[1600px] mx-auto px-3 sm:px-6 py-1.5 flex items-center justify-center gap-2 relative">
        <Link to="/dynasty50" className="flex items-center gap-1.5 no-underline text-black text-[11px] sm:text-xs font-bold uppercase tracking-wide hover:underline" data-testid="promo-banner-link">
          <Lightning size={13} weight="fill" />
          50% OFF PRO — {daysLeft} day{daysLeft !== 1 ? "s" : ""} left
          <span className="hidden sm:inline font-normal normal-case">· code DYNASTY50 · claim it now →</span>
        </Link>
        <button
          onClick={() => { setDismissed(true); localStorage.setItem("promo_dismissed_DYNASTY50", "1"); }}
          className="absolute right-2 sm:right-4 text-black/60 hover:text-black"
          aria-label="Dismiss promo banner"
          data-testid="promo-banner-dismiss"
        >
          <X size={14} weight="bold" />
        </button>
      </div>
    </div>
  );
}
